import { DATE_FORMATS } from '../constants/date'
import { CallPut } from '../enums/OrderTicket.enum'
import { formatDateIgnoringClientTime } from './formatDateIgnoringClientTime'

const orderTypeDict = {
  [CallPut.call]: 'C',
  [CallPut.put]: 'P',
  [CallPut.equity]: 'E',
}

/**
 * Generates a symbol string for an order based on the provided parameters.
 *
 * @param {Object} params - The parameters for generating the symbol.
 * @param {string} params.symbol - The base symbol (e.g., MSFT).
 * @param {string} params.expirationDate - The expiration date in YYYY-MM-DD format.
 * @param {2315 | 2314 | "EQUITY"} params.orderType - The order type. It can be:
 *   - `2315` for a Call option.
 *   - `2314` for a Put option.
 *   - `"EQUITY"` for equity orders.
 * @param {string} params.strikePrice - The strike price for the option.
 *
 * @returns {string} The generated symbol string, in the format: `.SYMBOLYYMMDDTYPESTRIKE`.
 *
 * @example
 * generateSymbol({
 *   symbol: 'MSFT',
 *   expirationDate: '2024-09-13',
 *   orderType: 2315,
 *   strikePrice: 380
 * });
 * // Returns: '.MSFT240913C380'
 */
export function generateOrderSymbol({
  symbol,
  expirationDate,
  orderType,
  strikePrice,
}) {
  let result = null

  if (!symbol || !orderTypeDict[orderType] || !expirationDate || !strikePrice) {
    return result
  }

  const formattedDate = formatDateIgnoringClientTime(
    expirationDate,
    DATE_FORMATS.yyMMdd
  )
  // NOTE: Remove ".0" if the strike price ends with ".0"
  const formattedStrikePrice = (+strikePrice).toString().replace(/\.0$/, '')

  result = `.${symbol}${formattedDate}${orderTypeDict[orderType]}${formattedStrikePrice}`

  return result
}
